export const FORGOT_PASSWORD = 'components/forgot-password/FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS ='components/forgot-password/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE ='components/forgot-password/FORGOT_PASSWORD_FAILURE';

export const forgotPassword = (data) => {
    return {
        type: FORGOT_PASSWORD,
        data
    }
}
export const forgotPasswordSuccess = (data) => {
    return {
        type: FORGOT_PASSWORD_SUCCESS,
        data
    }
}
export const forgotPasswordFailure = (data) => {
    return {
        type: FORGOT_PASSWORD_FAILURE,
        data
    }
}